<script lang="ts" setup>
import type { Policy } from "@/interfaces/policy";
import MultipleCountryPolicy from "@/modules/groups/components/MultipleCountryPolicy.vue";
import MultiplePolicy from "@/modules/groups/components/MultiplePolicy.vue";
import RangePolicy from "@/modules/groups/components/RangePolicy.vue";
import ValuePolicy from "@/modules/groups/components/ValuePolicy.vue";

interface Props {
  policy?: Policy;
}
const props = defineProps<Props>();

const getPolicyComponent = () => {
  switch (props.policy?.rule[0]?.type) {
    case "range": return RangePolicy;
    case "multiple":
      return props.policy.rule[0].field === "country" ? MultipleCountryPolicy : MultiplePolicy;
    default: return ValuePolicy;
  }
};
</script>

<template>
  <div
    v-if="policy"
    class="flex flex-col gap-2.5 p-4 rounded-xl border border-gray-200 bg-white hover:border-gray-300 hover:shadow-sm transition-all"
  >
    <!-- Name + flexible badge -->
    <div class="flex items-start justify-between gap-2">
      <h4 class="font-semibold text-sm text-gray-900 leading-snug">{{ policy.displayName }}</h4>
      <span
        class="flex-shrink-0 inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold"
        :class="policy.isFlexible
          ? 'bg-amber-50 text-amber-700 border border-amber-200'
          : 'bg-[#021F58]/5 text-[#021F58] border border-[#021F58]/15'"
      >
        <span class="material-symbols-outlined text-xs">{{ policy.isFlexible ? 'warning' : 'lock' }}</span>
        {{ policy.isFlexible ? 'Flexible' : 'Estricta' }}
      </span>
    </div>

    <!-- Description -->
    <p class="text-xs text-gray-500 leading-relaxed">{{ policy.description }}</p>

    <!-- Value / Range / Multiple -->
    <div class="pt-1 border-t border-gray-100">
      <component :is="getPolicyComponent() as any" :policy="policy" />
    </div>
  </div>
</template>
